<div style="margin: 16px;min-width: 350px;min-height: 500px">
  <form class="m-x--4">
    <mat-form-field class="m-x-4" appearance="outline">
      <input matInput [(ngModel)]="searchQuery" name="q" placeholder="Поиск"
             (ngModelChange)="this.userQuestionUpdate.next($event)">
    </mat-form-field>

  </form>

  <div *ngFor="let item of items ">
    <mat-card class="example-card">
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>{{item.name}}</mat-card-title>
          <mat-card-subtitle>{{item.price}} ₸</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!item.available" style="color: red;font-size: large">Нет в наличии
          </mat-card-subtitle>

          <img style="border-radius: 4px;max-width: 180px;max-height: 80px"
               mtxPhotoviewer
               [mtxPhotoviewerItems]="photos(item.photos)"
               [mtxPhotoviewerOptions]="{ index: 0 }"
               [src]="URLS.PHOTO_URL + item.photo"/>
        </mat-card-title-group>
      </mat-card-header>
      <mat-card-content style="margin-top: 20px">
        <a href="{{item.whatsApp}}" style="color: forestgreen">WhatsApp</a>
        <a href="{{item.telegram}}" style="color: deepskyblue;margin-left: 4px">Telegram</a>
      </mat-card-content>
    </mat-card>

  </div>

  <div *ngIf="hasNext">
    <button mat-button color="warn" (click)="next()">Загрузить еще</button>
  </div>


</div>
